export default {"src":"/_next/static/media/0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9.94d275b4.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};